import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { yandexReachGoal, googleEvent } from 'cityads-v3/utils/counterUtils'
import i18n from 'cityads-v3/i18n';

import CircularProgress from '@mui/material/CircularProgress'
import { slugify } from 'transliteration';
import Article from 'cityads-v3/components/Article/Article';
import PopupArticle from 'cityads-v3/components/PopupArticle/PopupArticle';

import { getNewsFields, parseNewsItem } from 'cityads-v3/utils/newsUtils';
import {
  getNewsById,
  getNewsTypes,
} from 'cityads-v3/actions/news';

import classes from './CurrentNewsItem.scss';

@withRouter
@connect(
  (state, props) => ({
    newsItem: state.news.newsById[props.id],
    newsItemLoading: state.news.isLoadingNewsById,
    newsTypesById: state.news.newsTypesById,
    newsTypesLoading: state.news.isLoadingNewsTypes,
    newsTypesLoaded: state.news.isNewsTypesLoaded,
    language: state.language.language,
  }),
  dispatch => bindActionCreators({
    getNewsById,
    getNewsTypes,
  }, dispatch)
)
@withTranslation(['News'], { i18n, wait: false })
export default class CurrentNewsItem extends Component {
  static propTypes = {
    id: PropTypes.number,
    open: PropTypes.bool.isRequired,
    baseRoute: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    canonicalBaseRoute: PropTypes.string,

    newsItem: PropTypes.object,
    newsItemLoading: PropTypes.bool,
    newsTypesById: PropTypes.object.isRequired,
    newsTypesLoading: PropTypes.bool,
    newsTypesLoaded: PropTypes.bool,
    language: PropTypes.string,

    getNewsById: PropTypes.func.isRequired,
    getNewsTypes: PropTypes.func.isRequired,

    t: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,

    counterOpen: PropTypes.string,
    counterGoToLink: PropTypes.string,
    counterCategory: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.state = {
      cachedNewsItem: props.newsItem
    };
  }

  componentDidMount() {
    const {
      id,
      newsItem,
      newsItemLoading,
      newsTypesLoading,
      newsTypesLoaded,
      getNewsById,
      getNewsTypes,
      counterOpen,
      counterCategory,
      open,
    } = this.props;

    if (id && !newsItem && !newsItemLoading) {
      getNewsById(id);
    }

    if (!newsTypesLoading && !newsTypesLoaded) {
      getNewsTypes();
    }

    if (counterOpen && open) {
      yandexReachGoal(counterOpen);
      googleEvent(counterCategory, counterOpen);
    }
  }

  componentDidUpdate(prevProps) {
    const { id, language, newsItem, getNewsById, getNewsTypes, counterOpen, counterCategory, open } = this.props;
    const { cachedNewsItem } = this.state;

    if (language !== prevProps.language) {
      getNewsTypes();
    }

    if (id && (language !== prevProps.language || id !== prevProps.id)) {
      getNewsById(id);
    }

    if (newsItem !== prevProps.newsItem && (newsItem || (cachedNewsItem && id && Number(cachedNewsItem.id) !== id))) {
      this.setState({
        cachedNewsItem: newsItem
      });
    }

    if (counterOpen && open && !prevProps.open) {
      yandexReachGoal(counterOpen);
      googleEvent(counterCategory, counterOpen);
    }

  }

  handleClickLink(evt) {
    const { history, counterGoToLink, counterCategory } = this.props;
    if (!counterGoToLink) {
      return;
    }

    for (var target = evt.target; target && target !== evt.currentTarget; target = target.parentNode) {
      if (target.matches('a')) {
        if (
          (target.host === window.location.host) &&
          (['publisher', 'main'].includes(target.pathname.split('/')[1]))
        ) {
          evt.preventDefault();
          history.push(target.pathname + target.search);
          if (counterGoToLink) {
            yandexReachGoal(counterGoToLink);
            googleEvent(counterCategory, counterGoToLink);
          }
        }
        break;
      }
    }
  }

  handleClose(evt) {
    evt.stopPropagation();

    const { history, baseRoute } =  this.props;

    if (baseRoute) {
      history.push(baseRoute);
    }
  }

  render() {
    const { t, open, baseRoute, canonicalBaseRoute, newsTypesById } = this.props;
    const { cachedNewsItem } = this.state;

    const newsOfferIds = cachedNewsItem?.offer_ids;
    const newsRoot = canonicalBaseRoute || (newsOfferIds?.length ? `/publisher/offer/${newsOfferIds[0]}/news` : '/main/news/all');

    const itemCategory = (cachedNewsItem && newsTypesById[cachedNewsItem.type_id]) ? t(`types.${newsTypesById[cachedNewsItem.type_id].name}`) : '';
    const newsRoute = cachedNewsItem ? `${newsRoot}/${cachedNewsItem.id}-${slugify(itemCategory)}` : '';
    const newsFields = cachedNewsItem ? getNewsFields(parseNewsItem(cachedNewsItem), t, newsRoute) : null;

    return (
      <PopupArticle
        open           = {open}
        onRequestClose = {(evt) => this.handleClose(evt)}
        closeLink      = {baseRoute}
        article        = {cachedNewsItem ?
          (
            <Article
              title     = {itemCategory}
              pageTitle = {itemCategory}
              onClick   = {this.handleClickLink.bind(this)}
            >
              {newsFields.moreText}
            </Article>
          ) :
          (
            <Article title="">
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            </Article>
          )
        }
      />
    );
  }
}
